import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { DeleteApplicationByIdResponse, DeleteApplicationByIdParams } from "api/api/applicationsApi/types";
import axios from "axios";

export const deleteApplicationById = createAsyncThunk<
  DeleteApplicationByIdResponse,
  DeleteApplicationByIdParams
>(
  "marathons/deleteApplicationById",
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      const data = await ApplicationsAPI.deleteApplicationById({ applicationId });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while deleting application", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      console.error("Error while deleting application", error);
      return rejectWithValue("Что-то пошло не так... Попробуйте обновить страницу");
    }
  }
);
